import { motion } from "framer-motion";
import { Reveal, Label } from "./Motion";
import { CANDLE_TYPES } from "../data";

export const CandleEdit = ({ scrollTo }) => (
  <section id="candles" data-testid="candle-edit" className="relative py-24 md:py-36 bg-[#EAE5DC]">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
        <div>
          <Reveal><Label>The Candle Edit</Label></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl text-[#2c2826] leading-[1.02]">
              A variety of<br /><span className="italic text-[#985F47]">warm light.</span>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <p className="max-w-sm text-[#5a5451] leading-relaxed">
            From steady pillars to scented jars and scattered tealights —
            candles for every mood, table and celebration.
          </p>
        </Reveal>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
        {CANDLE_TYPES.map((c, i) => (
          <Reveal key={c.id} delay={(i % 4) * 0.08}>
            <motion.button
              data-testid={`candle-${c.id}`}
              onClick={() => scrollTo("enquire")}
              whileHover="hover"
              className="group relative block w-full text-left overflow-hidden"
            >
              <div className={`relative aspect-[4/5] overflow-hidden ${c.bgClass || "bg-[#D6CFC4]"}`}>
                <motion.img
                  src={c.img} alt={c.name}
                  variants={{ hover: { scale: 1.06 } }}
                  transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                  className={`h-full w-full ${c.fit === "contain" ? "object-contain object-top pt-6" : "object-cover"}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#2c2826]/70 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 p-6 md:p-7">
                  <h3 className="font-serif text-2xl md:text-3xl text-[#F7F5F0]">{c.name}</h3>
                  <p className="mt-2 max-w-xs text-[#e7ddcf] text-sm leading-relaxed">{c.desc}</p>
                  <div className="mt-3 flex flex-wrap gap-2">
                    {c.scents.map((s) => (
                      <span key={s} data-testid={`scent-${c.id}-${s.toLowerCase().replace(/\s+/g, "-")}`}
                        className="rounded-full border border-[#F7F5F0]/40 bg-[#F7F5F0]/10 backdrop-blur-sm px-3 py-1 text-[11px] tracking-wide text-[#F7F5F0]">
                        {s}
                      </span>
                    ))}
                  </div>
                  <span className="mt-4 inline-flex items-center gap-2 text-[#F7F5F0] text-sm border-b border-[#F7F5F0]/50 pb-0.5 group-hover:border-[#E8942E] group-hover:text-[#E8942E] transition-colors duration-300">
                    Enquire &rarr;
                  </span>
                </div>
              </div>
            </motion.button>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
